import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./i18n";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { reactQueryClient } from "./service";
import { QueryClientProvider } from "react-query";
import { BrowserRouter as Router } from "react-router-dom";
import dayjs from "dayjs";
import "dayjs/locale/pl";
import { GlobalContextProvider } from "./contexts/global-context/GlobalContextProvider";
import { ImpersonationProvider } from "./contexts/impersonation-context/ImpersonationContext";
import { ThemeContextProvider } from "./contexts/theme-context/ThemeContextProvider";

dayjs.locale("pl");

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <ThemeContextProvider>
    <GlobalContextProvider>
      <ImpersonationProvider>
        <Router>
          <QueryClientProvider client={reactQueryClient}>
            <App />
          </QueryClientProvider>
        </Router>
      </ImpersonationProvider>
    </GlobalContextProvider>
  </ThemeContextProvider>
);

reportWebVitals();
